// constants/processingStates.js
export const TERMINAL_STATES = [
  'PROCESS_COMPLETED',
  'PROCESS_FAILED',
  'PROCESS_PARTIALLY_COMPLETED',
  'BEDROCK_FAILS',
  'VALIDATION_FAILED',
  'VALIDATION_REJECTED',
  'UNSUPPORTED_MEDIA_TYPE',
  'DUPLICATE_SKIPPED',
];

export const STATUS_LABELS = {
  RECEIVED: 'Recibido',
  REPROCESS_QUEUED: 'Reprocesando…',
  TEXT_EXTRACTION_IN_PROGRESS: 'Extrayendo texto',
  TEXT_EXTRACTION_DONE: 'Texto extraído',
  BEDROCK_IN_PROGRESS: 'Clasificando',
  BEDROCK_DONE: 'Clasificado',
  OCR_IN_PROGRESS: 'OCR en progreso',
  UNSUPPORTED_MEDIA_TYPE: 'Formato no soportado',
  DUPLICATE_SKIPPED: 'Archivo duplicado',
  TEXT_EXTRACTION_FAILED: 'Error de extracción de texto',
  SCANNED_PDF_NOT_SUPPORTED: 'PDF escaneado no soportado',
  PROCESS_COMPLETED: 'Procesado',
  PROCESS_FAILED: 'Error',
};

export const STATUS_TOOLTIPS = {
  UNSUPPORTED_MEDIA_TYPE:
    'Solo se procesan PDF con texto seleccionable, TXT y CSV. Imágenes y otros formatos no están soportados.',
  DUPLICATE_SKIPPED:
    'Este archivo ya fue procesado anteriormente. Se omitió el reprocesamiento.',
};

export const isTerminalState = (status) => {
  if (!status) return false;
  return TERMINAL_STATES.includes(status.toUpperCase());
};

export const isReprocessingStatus = (status) => (
  (status || '').toUpperCase() === 'REPROCESS_QUEUED'
);

export const isProcessing = (status) => !isTerminalState(status);

export const getActiveProcessingLabel = (status) => (
  isReprocessingStatus(status) ? 'Reprocesando' : 'Procesando'
);

export const getStatusLabel = (status, errorCode) => {
  if (errorCode === 'SCANNED_PDF_NOT_SUPPORTED') {
    return STATUS_LABELS.SCANNED_PDF_NOT_SUPPORTED;
  }
  return STATUS_LABELS[status] || status;
};
